import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useRecoilValueLoadable } from "recoil";
import { userAtom } from "@state/State";
import { PF_SERVER_URL } from "../../Constants";
import localforage from "localforage";

const COOLDOWN_MS = 30 * 60 * 1000;
const cooldownKey = (id: string) => `remind_cooldown_${id}`;

export const useSendEvidenceReminder = (programID: string | undefined, evidenceID: string | undefined) => {
  const user = useRecoilValueLoadable(userAtom);
  const [remindedAt, setRemindedAt] = useState<Date | null>(null);

  useEffect(() => {
    if (!evidenceID) return;
    localforage.getItem<number>(cooldownKey(evidenceID)).then((ts) => {
      if (!ts) return;
      if (Date.now() - ts < COOLDOWN_MS) setRemindedAt(new Date(ts));
    });
  }, [evidenceID]);

  const mutation = useMutation({
    mutationFn: async () => {
      const response = await fetch(`${PF_SERVER_URL}/portfolio/Workflows/sendEvidenceReminderEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Token: user.contents?.token,
          ContactID: `${user.contents?.userData.contactID}`,
          programID,
          evidenceID,
        }),
      });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      return response.json();
    },
    onSuccess: () => {
      if (!evidenceID) return;
      const now = Date.now();
      localforage.setItem(cooldownKey(evidenceID), now);
      setRemindedAt(new Date(now));
    },
    onError: () => {
      window.alert("An error occurred when sending the reminder email");
    },
  });

  return { ...mutation, isCoolingDown: remindedAt !== null, remindedAt };
};
